import {Injectable} from '@angular/core';
import {Parser} from '@json2csv/plainjs';
import {saveAs} from 'file-saver';

@Injectable()
export class DownloadCsvService {

  public downloadFile(data: any, opts, filename = 'data.csv') {
    const csvData = this.convertToCSV(data, opts);
    const file = new Blob([csvData], {type: 'text/csv;charset=utf-8'});
    saveAs(file, filename);
  }

  public convertToCSV(objArray: any, opts) {
    const parser = new Parser(opts);
    const csv = parser.parse(objArray);
    console.log(csv);
    return csv;
  }
}
